const Theme = {
  grass: {
    main:  "var(--dark-green)",
    secondary: "var(--light-green)"
  },
  normal: {
    main: "var(--dark-gray)",
    secondary: "var(--light-gray)"},
  water: {
    main: "var(--dark-blue)", 
    secondary: "var(--light-blue)"
  },
  poison: {
    main: "var(--light-purple)",
    secondary: "var(--dark-purple)"
  },
  electric: {
    main: "var(--dark-yellow)",
    secondary : "var(--light-yellow)"
  },
  ground: {
    main: "var(--dark-brown)", 
    secondary: "var(--light-brown)"
  },
  rock: {
    main: "var(--light-brown)", 
    secondary: "var(--dark-brown)"
  },
  bug: {
    main: "var(--light-green)",
    secondary: "var(--dark-green)"
  },
  fire: {
    main: "var(--dark-red)",
    secondary: "var(--light-red)"
  },
  flying: {
    main: "var(--light-gray)",
    secondary: "var(--dark-gray)"
  },
  fairy: {
    main: "var(--light-pink)",
    secondary: "var(--light-purple)"
  },
  psychic: {
    main: "var(--violet)",
    secondary: "var(--light-pink)"
  },
  fighting: {
    main: "var(--orange)",
    secondary: "var(--light-red)"
  },
  ghost: {
    main: "var(--dark-purple)",
    secondary: "var(--light-purple)"
  },
  ice: {
    main: "var(--light-blue)",
    secondary: "var(--light-gray)"
  },
  dragon: {
    main: "var(--dragon)",
    secondary: "var(--dark-red)"
  },
  dark: {
    main: "var(--black)",
    secondary: "var(--light-black)"
  },
  steel: {
    main: "var(--metallic-gray)",
    secondary: "var(--light-black)"
  }
}

export default Theme